import { Component } from '@angular/core';

@Component({
  selector: 'app-mysettings',
  templateUrl: './mysettings.component.html',
  styleUrl: './mysettings.component.scss'
})
export class MysettingsComponent {

}
